import { isWithinInterval, isAfter, parseISO } from 'date-fns';
import { StayDates } from '../DatesForm';

export const doDatesContain = (outer: StayDates, inner: Partial<StayDates> = {}) => {
  if (!inner.checkIn || !inner.checkOut) {
    return false;
  }

  if (isAfter(parseISO(outer.checkIn), parseISO(outer.checkOut)) || isAfter(parseISO(inner.checkIn), parseISO(inner.checkOut))) {
    return false;
  }

  return (
    isWithinInterval(parseISO(inner.checkIn), { start: parseISO(outer.checkIn), end: parseISO(outer.checkOut) }) &&
    isWithinInterval(parseISO(inner.checkOut), { start: parseISO(outer.checkIn), end: parseISO(outer.checkOut) })
  );
};
